import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "lastUpdated"];
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import getUsersISOLocale from 'utils/i18n/getUsersISOLocale';
import useUniqueId from 'hooks/useUniqueId';
var LastUpdatedField = function LastUpdatedField(_ref) {
  var id = _ref.id,
    lastUpdated = _ref.lastUpdated,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  var date = lastUpdated ? new Date(lastUpdated) : new Date();
  return /*#__PURE__*/React.createElement(FormField, _extends({
    label: t('form_last_updated_colon'),
    labelId: uniqueId
  }, otherProps), Intl.DateTimeFormat(getUsersISOLocale(), {
    month: 'short',
    year: 'numeric',
    day: 'numeric'
  }).format(date));
};
export default LastUpdatedField;